<template>
	<div>
		<QuestionCard
			title="Provide these details to your Identity Provider"
			description="These URLs tell your Identity Provider where to send users before and after authentication, so Cassie can log them in and out correctly."
		>
			<v-row dense>
				<v-col cols="12">
					<TextField
						:value="loginUrl"
						label="Login URL"
						readonly
						explainer="Share this with your end users as the entry point to the Cassie Portal.  All SSO logins will start here."
					>
						<template #append>
							<IconButton
								tooltip-text="Copy to Clipboard"
								@click="copyToClipboard(loginUrl)"
							>
								mdi-content-copy
							</IconButton>
						</template>
					</TextField>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12">
					<TextField
						:value="redirectUri"
						label="SSO Provider Redirect URI"
						readonly
						explainer="Add this to your Identity Provider’s configuration as the Callback or Redirect URI.
After users sign in, your Identity Provider sends them here so Cassie can complete authentication."
					>
						<template #append>
							<IconButton
								tooltip-text="Copy to Clipboard"
								@click="copyToClipboard(redirectUri)"
							>
								mdi-content-copy
							</IconButton>
						</template>
					</TextField>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<TextField
						:value="logoutUri"
						label="Post Logout Redirect URI"
						readonly
						explainer="Configure this in your Identity Provider as the Post-Logout Redirect.
When a user signs out, they’ll be sent here to fully log out of Cassie."
					>
						<template #append>
							<IconButton
								tooltip-text="Copy to Clipboard"
								@click="copyToClipboard(logoutUri)"
							>
								mdi-content-copy
							</IconButton>
						</template>
					</TextField>
				</v-col>
			</v-row>
		</QuestionCard>
	</div>
</template>

<script>
import { QuestionCard } from '../../../../components/component-library-wrapper.js'
import TextField from '../../../../../../shared/components/text-field.vue'
import copyToClipboard from '../../../../../../shared/mixins/copy-to-clipboard.js'
import IconButton from '../../../../../../shared/components/icon-button.vue'
import { getEnv } from '../../../../../../shared/utils/runtime-settings.js'
import { showSnackbar } from '../../../../../../shared/state/snackbar.js'

export default {
	components: {
		QuestionCard,
		TextField,
		IconButton
	},
	mixins: [copyToClipboard],
	props: {
		ssoConfiguration: Object,
		lookupData: Object
	},
	computed: {
		loginUrl () {
			const preferred = this.ssoConfiguration?.redirectLoginUrl
			if (preferred) return this.ensureHttpsPrefix(preferred)

			const fallback = this.ssoConfiguration?.productId === 1
				? this.lookupData?.vueAdminPortalURL
				: this.lookupData?.vueCSPortalURL

			return this.ensureHttpsPrefix(fallback)
		},

		redirectUri () {
			if (!this.ssoConfiguration.tenantGuid) {
				return ''
			}
			let authBase = ''
			try {
				authBase = getEnv('VUE_APP_BASE_URL_AUTH')
			} catch (e) {
				showSnackbar('Unable to load authentication base URL', { color: 'error' })
				return ''
			}

			authBase = authBase.replace(/\/$/, '')
			return `${authBase}/signin/${this.ssoConfiguration.tenantGuid}`
		},

		logoutUri () {
			const preferred = this.ssoConfiguration?.finalLogoutRedirectUrl
			if (preferred) return this.ensureHttpsPrefix(preferred)

			const basePortal = this.ssoConfiguration?.productId === 1 ? this.lookupData?.vueAdminPortalURL : this.lookupData?.vueCSPortalURL

			return basePortal
				? `${this.ensureHttpsPrefix(basePortal).replace(/\/+$/, '')}/sso/logout`
				: ''
		}
	},
	methods: {
		ensureHttpsPrefix (url) {
			if (!url) return ''
			if (!/^https?:\/\//i.test(url)) {
				return `https://${url}`
			}
			return url
		}
	}
}
</script>
